interface ILikedIconProps {
  idPrefix?: string;
  className?: string;
}

export const LikeIcon = ({ idPrefix, className }: ILikedIconProps) => {
  const gradientId = idPrefix ? `${idPrefix}-liked-gradient` : "liked-gradient";

  return (
    <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill={`url(#${gradientId})`} d="M16.0003 28C17.3337 28 29.3337 21.3337 29.3337 12.0006C29.3337 7.33409 25.3337 4.05873 21.3337 4.00086C19.3337 3.97192 17.3337 4.66753 16.0003 6.66745C14.667 4.66753 12.6324 4.00086 10.667 4.00086C6.66699 4.00086 2.66699 7.33409 2.66699 12.0006C2.66699 21.3337 14.667 28 16.0003 28Z"/>
      <defs>
        <linearGradient id={gradientId} x1="16.1437" y1="9.99999" x2="16.1437" y2="13.2727" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EBFA63"/>
          <stop offset="1" stopColor="#DAF02B"/>
        </linearGradient>
      </defs>
    </svg>
  );
};
